/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelSalesStatus.ts                   *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/crm/sales-status";

export class AutogenModelSalesStatus<RowType extends ModelRow> extends Endpoint<RowType, RowSalesStatusFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowSalesStatus extends ModelRow<RowSalesStatusFields> {
	constructor(values?: Partial<RowSalesStatusFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowSalesStatusFields {
	company_id: string;
	descr: string;
	id: string;
}

